<template>
    <div class="page-layout blank contacts-manage">
        <div class="d-flex align-items-center justify-content-center mt-40" v-if="pageDataLoading">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div v-else class="pb-10 pr-3 pl-3">
            <!-- Breadcrumb Section -->
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between align-items-center">
                    <div class="breadcrumbnew">
                        <div><router-link to="/salesDashboard" class="text-white pl-2 text-line">Sales Dashboard</router-link></div>
                        <span>Deals</span>
                    </div>
                    <div class= "d-flex justify-content-between align-items-center">
                        <button class="btn btn-des-small ml-2 mr-6 float-right text-white" v-if="userPermissions.deals.permitted_actions.create" @click="$router.push('/deals/create/new')" style="background:#128807; height:30px">+Add New Deal</button>
                        <div class= "d-flex justify-content-between align-items-center">
                            <div class="dropdown-label">Period : </div>
                            <div class="dropdown perioddropdown">
                            <ul class='nav nav-tabs'>
                                <li class='nav-item dropdown'>
                                <a aria-expanded='false' aria-haspopup='true' class='nav-link dropdown-toggle dropdown-button on-focus' data-toggle='dropdown' href='#' role='button'>
                                    <span v-if="this.period_data == 'fiscal_year'">Fiscal Year</span>
                                    <span v-if="period_data == 'h1'">Semi Annual H1</span>
                                    <span v-if="period_data == 'h2'">Semi Annual H2</span>
                                    <span v-if="period_data == 'q1'">Quarter Q1</span>
                                    <span v-if="period_data == 'q2'">Quarter Q2</span>
                                    <span v-if="period_data == 'q3'">Quarter Q3</span>
                                    <span v-if="period_data == 'q4'">Quarter Q4</span>
                                    <span v-if="this.period_data == 'month'">Month</span>
                                </a>
                                <div class='dropdown-menu period-dropdown-menu'>
                                    <a @click="getData('fiscal_year')" class='dropdown-item' href='#'>Fiscal Year</a>
                                    <div class='dropdown-item dropdown-submenu period-dropdown'>
                                    <a class='dropdown-item dropdown-item-toggle' data-toggle='dropdown' href='#'>Semi-Annual</a>
                                    <div class='dropdown-menu period-dropdown-menu sub-dropdown'>
                                        <a @click="getData('h1')"  class='dropdown-item' href='#'>H1</a>
                                        <a @click="getData('h2')"  class='dropdown-item' href='#'>H2</a>
                                    </div>
                                    </div>
                                    <div class='dropdown-item dropdown-submenu period-dropdown'>
                                    <a class='dropdown-item dropdown-item-toggle' data-toggle='dropdown' href='#'>Quarter</a>
                                    <div class='dropdown-menu period-dropdown-menu sub-dropdown'>
                                        <a @click="getData('q1')"  class='dropdown-item' href='#'>Q1</a>
                                        <a @click="getData('q2')"  class='dropdown-item' href='#'>Q2</a>
                                        <a @click="getData('q3')"  class='dropdown-item' href='#'>Q3</a>
                                        <a @click="getData('q4')"  class='dropdown-item' href='#'>Q4</a>
                                    </div>
                                    </div>
                                    <a @click="getData('month')" class='dropdown-item' href='#'>Month</a>
                                </div>
                                </li>
                            </ul>
                        </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 mt-3">
                    <button class="btn btn-des-small ml-2 mr-2 float-right text-white" @click="$router.push('/deals/create/new')" style="background:#008a63; ">+
                        Add New Deal</button>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 float-right mt-2 d-flex">
                     <ul role="menubar" class="menuScroll flexScroll">
                        <li role="menuitem" tabindex="0" class="nav-item dropdown dc-menu-item">
                            <el-tooltip class="item pull-right" effect="dark" content="Fiscal Year" placement="top">
                                <a href="javascript:;" class="nav-link menulink d-flex align-items-center"
                                    id="navbarOrderLink" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false" >
                                    <span class="font-weight-bold text-capitalize" >{{period_data.replace(/_/g, " ")}}</span>
                                    <div class="mt-2">
                                        <i class="icon icon-chevron-down" style="color: #fff"></i>
                                    </div>
                                </a>
                            </el-tooltip>
                            <ul class="dropdown-menu period_change dropdown-width datasubMenuScroll subFlexScroll open"
                                aria-labelledby="dropdownMenuLink" >
                                <li  class="data-submenu drop-sub" >
                                    <a href="javascript:;" tabindex="-1" @click="getData('fiscal_year')"
                                        class="d-flex dropdown-sub-item  justify-content-between align-items-center dropdown-item  togglePlace scm-menu"
                                        style="padding-right:0px !important">Fiscal Year

                                    </a>
                                </li>
                                <li  class="data-submenu" >
                                    <a href="javascript:;" tabindex="-1"
                                        class="d-flex  justify-content-between align-items-center dropdown-item dropdown-toggle togglePlace scm-menu"
                                        style="padding-right:0px !important">Semi-Annual

                                        <div class="mt-2"> <i class="icon icon-chevron-right"></i></div>
                                    </a>
                                    <ul class="dropdown-menu closeMenu crm-submenu datasubMenuScroll subFlexScroll">
                                        <li class="drop-sub" >
                                            <a @click="getData('h1')" class="dropdown-sub-item  nav-link pointer">H1</a>
                                        </li>
                                        <li class="drop-sub" >
                                            <a @click="getData('h2')" class="dropdown-sub-item  nav-link pointer">H2</a>
                                        </li>
                                    </ul>
                                </li>

                                <li class="data-submenu">
                                    <a href="javascript:;" tabindex="-1"
                                        class="d-flex justify-content-between align-items-center dropdown-item dropdown-toggle togglePlace scm-menu"
                                        style="padding-right:0px !important">Quarter
                                        <div class="mt-2"><i class="icon icon-chevron-right"></i></div>
                                    </a>
                                    <ul class="dropdown-menu closeMenu crm-submenu datasubMenuScroll subFlexScroll">
                                        <li class="drop-sub" >
                                            <a   @click="getData('q1')" class="dropdown-sub-item  nav-link pointer">Q1</a>
                                        </li>
                                        <li class="drop-sub" >
                                            <a  @click="getData('q2')" class="dropdown-sub-item  nav-link pointer">Q2</a>
                                        </li>
                                        <li class="drop-sub" >
                                            <a  @click="getData('q3')" class="dropdown-sub-item  nav-link pointer">Q3</a>
                                        </li>
                                        <li class="drop-sub" >
                                            <a  @click="getData('q4')" class="dropdown-sub-item nav-link pointer">Q4</a>
                                        </li>
                                    </ul>
                                </li>

                                <li class="data-submenu drop-sub" >
                                    <a href="javascript:;" tabindex="-1" @click="getData('month')"
                                        class="d-flex justify-content-between align-items-center dropdown-item data-drop dropdown-sub-item  togglePlace scm-menu"
                                        style="padding-right:0px !important">Month

                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div> -->
            </div>
            <div class="row">
                <!-- Deals pipeline table view Section -->
                <div class="col-lg-12 col-sm-12 col-md-12 mt-3">
                    <fullscreen class="box-radius bg-white" ref="pipeline" @change="dataChange('pipeline')" >
                        <div class="card-item deals-cards bg-white text-auto pb-0">
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 pr-5 fs-14">Deals in Pipeline</div>
                                <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('pipeline'), dealsPipeline()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt />
                                </button>
                            </div>

                            <div class="col-lg-12 col-md-12 col-sm-12 pl-0 pr-0">
                                <div id="salesValue" class="mt-3 salesValue">
                                    <table class="table table-properties team-listview-table text-left w-100 ">
                                        <thead v-if="deals_pipeline_list.length != 0">
                                            <tr>
                                                <th class="w-1 whiteSpace pl-6 pr-4">Deal Name</th>
                                                <th class="whiteSpace">Pipeline</th>
                                                <th class="whiteSpace">Product</th>
                                                <th class="whiteSpace">Amount</th>
                                                <th class="whiteSpace">Terrritory</th>
                                                <th class="whiteSpace">Total Stages</th>
                                                <th class="whiteSpace">Total Time <br>Invested (days)</th>
                                                <th class="whiteSpace">Predicted <br>Probability</th>
                                                <th class="whiteSpace">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="w-100" v-if="ajaxCallInProgress">
                                                <td colspan="15">
                                                    <div class="d-flex align-items-center justify-content-center w-100 pt-8"
                                                        v-if="ajaxCallInProgress">
                                                        <half-circle-spinner :animation-duration="1000" :size="50"
                                                            color="#00448b" style="margin: 0 auto;" />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-else-if="!ajaxCallInProgress && deals_pipeline_list.length == 0" class="text-center">
                                                <td colspan="15">
                                                    <img src="/static/images/territory-sales.png" class="mb-3 pt-7 sales-list"/>
                                                    <div class="text-center pt-3 text-muted fw-500">No deals in pipeline!</div>
                                                </td>
                                            </tr>
                                            <tr v-else v-for="data in deals_pipeline_list" :key="data.id">
                                                <td class="text-secondary pl-6 pr-4">{{data.name}}</td>
                                                <td>{{data.pipeline}}</td>
                                                <td>
                                                    <div class="d-flex align-items-center">
                                                        <span>{{data.product_count ? data.products[0] : "-"}}</span><br />
                                                        <el-popover
                                                            v-if="data.products.length > 1"
                                                            placement="bottom"
                                                            width="200"
                                                            trigger="hover">
                                                            <div v-for="(product,index) in data.products" :key="index">
                                                                <span class="fw-500">{{product}}</span>
                                                            </div>
                                                            <el-button slot="reference" class="pl-0 pr-0">
                                                                <div class="fw-500 mt-4px text-center text-secondary">
                                                                    +{{data.product_count - 1}} more
                                                                </div>
                                                            </el-button>
                                                        </el-popover>
                                                    </div>
                                                </td>
                                                <td>{{data.total_transaction_value}}</td>
                                                <td>{{data.territory ? data.territory[0] : "-"}}</td>
                                                <td>{{data.total_stages}}</td>
                                                <td>{{data.days}}</td>
                                                <td>{{data.predicted_probability}}</td>
                                                <td class="text-capitalize">{{data.status.replace("_", " ")}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
            </div>
            <div class="row mt-3">
                <!-- Amount in pipeline Section -->
                <div class="col-lg-7 col-md-7 col-sm-12 pr-1">
                    <fullscreen class="box-radius bg-white" ref="amountpipe" @change="dataChange('amountpipe')" >
                        <div class="card-item bg-white text-auto pb-0">
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 fs-14">Amount in Pipeline</div>
                                <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('amountpipe'), amountPipeline()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt />
                                </button>
                            </div>
                            <div class="d-flex align-items-center justify-content-center" v-if="loadAmountInPipelineSection" style="height: 352px;">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="row">
                                <div class="col-lg-12 pl-0">
                                    <div id="pipelineDiv" class="mt-3 pipelineDiv"></div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
                <!-- Target Achieved by team Section -->
                <div class="col-lg-5 col-md-5 col-sm-12 pl-2">
                    <fullscreen class="box-radius bg-white" ref="target" @change="dataChange('target')" >
                        <div class="card-item bg-white text-auto pb-0">
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 fs-14">Target achieved by Team</div>
                                <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('target'), teamTarget()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt />
                                </button>
                            </div>
                            <div class="d-flex align-items-center justify-content-center" v-if="loadTargetAchievedSection" style="height: 352px;">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="row">
                                <div class="col-lg-12">
                                    <div id="targetDiv" class="mt-3 targetDiv"></div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
            </div>

            <div class="row mt-3">
                <!-- Revenue Generated Section -->
                <div class="col-lg-6 col-sm-12 col-md-6 pr-3">
                    <fullscreen class="box-radius bg-white" ref="revenue" @change="dataChange('revenue')" >
                        <div class="p-3">
                            <div class="d-flex justify-content-between aline-items-center mt-1">
                                <div class="fw-600 fs-14">Revenue Generated</div>
                                <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('revenue'), revenueGene()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt />
                                </button>
                            </div>
                            <div v-if="dateRange.length" style="border-bottom: 1px solid #a9aaad;">
                                <div class="d-flex justify-content-between align-items-center"
                                    style="background: #41b883; border-radius: 12px; padding-left: 10px; padding-right: 10px; margin-top: 4px; margin-bottom: 8px; width: 16em;">
                                    <input type="text"
                                        :value="('0'+new Date(dateRange[0]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[0]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[0]).getFullYear()+' to '+('0'+new Date(dateRange[1]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[1]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[1]).getFullYear()"
                                        style="color: #fff; background: #41b883; width: 14em;" disabled />
                                    <span
                                        @click="dataClose(),dateRange= []"
                                        style="color: #fff; cursor: pointer;">&#10005;</span>
                                </div>
                            </div>
                            <date-picker v-else @change="updatecreationDate()" v-model="dateRange" format="DD/MM/YYYY"
                                    range class="date-width calendar-edit-per callreport-listdate calendar-height-top" :show-second="false"
                                :lang="lang" :clearable="true" confirm :not-after="new Date()" confirm-text="APPLY" type="date">
                            </date-picker>
                        </div>
                        <div class="d-flex align-items-center justify-content-center" v-if="loadRevenueGeneratedSection" style="height: 368px;">
                            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                        </div>
                        <div v-else class="card-item bg-white text-auto pb-0">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div id="revenueDiv" class="mt-3 revenueDiv"></div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
                <!-- Sales Generated by sales person Section -->
                <div class="col-lg-6 col-sm-12 col-md-6 pl-0">
                    <fullscreen class="box-radius bg-white" ref="sales" @change="dataChange('sales')" >
                        <div class="card-item bg-white text-auto pb-0">
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 fs-14">Sales generated by Sales person</div>
                                <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('sales'), personSales()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt />
                                </button>
                            </div>
                            <div class="d-flex align-items-center justify-content-center" v-if="loadSalesGeneratedSection" style="height: 412px;">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="row">
                                <div class="col-lg-12">
                                    <div id="salesDiv" class="mt-3 salesDiv"></div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import {ref} from 'vue'
import dashboard from '../mixins/dashboard';
import {HalfCircleSpinner} from "epic-spinners";
import { SweetModal } from 'sweet-modal-vue';
import convert from "../mixins/convert.js";
    export default {
        data() {
            return {
                loadSalesGeneratedSection: false,
                loadRevenueGeneratedSection: false,
                loadTargetAchievedSection: false,
                loadAmountInPipelineSection: false,
                currency:'',
                pageDataLoading: false,
                ajaxCallInProgress: false,
                time_period: 'fiscal_year',
                period_data:'fiscal_year',
                warning_msg: '',
                success_msg: '',
                show: false,
                between:'',
                chart: {},
                skip:0,
                limit:10,
                selected_type: "today",
                select_month: null,
                open: false,
                period_options: ['FiscalYear', 'Semi-Annual', 'Quarter', 'Month'],
                semi_options: ['H1', 'H2'],
                quarter_options: ['Q1', 'Q2', 'Q3', 'Q4'],
                deals_pipeline_list: [],
                amount_pipeline_list: [],
                target_achieved: [],
                sales_generated: [],
                revenue_generated_data: [],
                graph_scale:[],
                created_report_date: [new Date() , new Date()],
                dateRange: [],
                rangeDate: [],
                creation_date: [],
                pickerOptions:{
                    disabledDate(time){
                        return time.getTime() > Date.now();
                    }
                },
                lang: {
                    type: "en",
                    days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                    months: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    pickers: [
                        "next 7 days",
                        "next 30 days",
                        "previous 7 days",
                        "previous 30 days"
                    ],
                    placeholder: {
                        date: "Select Date",
                        dateRange: "Select Date Range"
                    },


                },
            }
        },
        mixins: [dashboard,convert],
        components: {
            HalfCircleSpinner,
            SweetModal
        },
        methods: {
            dataClose(){
                let date = this.rangeDate
                let start_date = this.convertFilter(date[0])
                let end_date = this.convertFilter(date[1])
                let newValue = start_date + ',' + end_date
                newValue = newValue.split(",")
                this.created_report_date = newValue
                this.loadRevenueGenerstedAPI()
            },
            //Fullscreen add/remove class methods
            amountPipeline(){
                var amountPipeline = document.getElementById('pipelineDiv')
                amountPipeline.classList.toggle('pipelineDiv')
                amountPipeline.classList.toggle('pipelineDiv-expand')
            },
            teamTarget(){
                var teamTarget = document.getElementById('targetDiv')
                teamTarget.classList.toggle('targetDiv')
                teamTarget.classList.toggle('targetDiv-expand')
            },
            revenueGene(){
                var revenueGen = document.getElementById('revenueDiv')
                revenueGen.classList.toggle('revenueDiv')
                revenueGen.classList.toggle('revenueDiv-expand')
            },
            personSales(){
                var personSales = document.getElementById('salesDiv')
                personSales.classList.toggle('salesDiv')
                personSales.classList.toggle('salesDiv-expand')
            },
            dealsPipeline(){
                var dealsPipeline = document.getElementById('salesValue');
                dealsPipeline.classList.toggle('salesValue');
                dealsPipeline.classList.toggle('salesValue-expand');
            },
            dateSettings(){
                let date = []
                var dateOffset = (24*60*60*1000) * (365*5); //5 yrs
                var newDate = this.convertFilter(new Date());
                var oldDate = new Date();
                oldDate.setTime(oldDate.getTime() - dateOffset);
                this.created_report_date= [this.convertFilter(oldDate),newDate]
                this.rangeDate = [this.convertFilter(oldDate),newDate]
            },
            updatecreationDate(){
                if (this.dateRange) {
                    let start_date = this.convertFilter(this.dateRange[0])
                    let end_date = this.convertFilter(this.dateRange[1])
                    let newValue = start_date + ',' + end_date
                    newValue = newValue.split(",")
                    this.created_report_date = newValue
                    this.loadRevenueGenerstedAPI()
                } else {
                    this.creation_date = ''
                    this.created_report_date = ''
                }
                this.$forceUpdate()

            },
            //Set semi anual and quarter values
            getData(value){
                this.period_data = value
                if(value == 'h1'|| value == 'h2' ){
                    this.time_period = 'semi_annual'
                    this.between = value
                }
                else if(value == 'q1'|| value == 'q2' || value == 'q3' || value == 'q4'){
                    this.time_period = 'quarter'
                    this.between = value
                } else {
                    this.time_period = value
                    this.between = ''
                }
                this.loadTargetAchievedByTeamData(),
                this.loadDealsInPipelineData(),
                this.loadAmountInPipelineDataAPI(),
                this.loadSalesGeneratedPerPersonAPI()
            },
            //Fullscreens add/remove classes methods
            expandData(value) {
                if(value == 'sales'){
                    this.$refs["sales"].toggle();
                    this.personSales();
                } else if(value == 'revenue'){
                    this.$refs["revenue"].toggle();
                    this.revenueGene();
                } else if(value == 'target'){
                    this.$refs["target"].toggle();
                    this.teamTarget();
                }else if(value == 'amountpipe'){
                    this.$refs["amountpipe"].toggle();
                    this.amountPipeline();
                }else if(value == 'pipeline'){
                    this.$refs["pipeline"].toggle();
                    this.dealsPipeline();
                }
            },
            dataChange(value) {
                if(value == 'sales'){
                    this.sales = value;
                    this.personSales();
                } else if(value == 'revenue'){
                    this.revenue = value;
                    this.revenueGene();
                } else if(value == 'target'){
                    this.target = value;
                    this.teamTarget();
                }else if(value == 'amountpipe'){
                    this.amountpipe = value;
                    this.amountPipeline();
                } else if(value == 'pipeline'){
                    this.pipeline = value;
                    this.dealsPipeline();
                }
            },
            handleChange(value, type) {
                if (type === 'second') {
                    this.open = false;
                }
            },
            display() {
                this.show = !this.show
            },
            async showMonthPicker() {
                this.open = true
            },
            //API call to load deals pipeline data
            async loadDealsInPipelineData(){
                this.ajaxCallInProgress = true;
                let params = {
                    period: this.time_period,
                    between: this.between,
                    skip: this.skip,
                    limit:this.limit
                }
                let response = await this.getDealsInPipelineData(params)
                this.deals_pipeline_list = response.response
                this.ajaxCallInProgress = false;
            },
            //API call to get amount in pipeline data
            async loadAmountInPipelineDataAPI(){
                this.loadAmountInPipelineSection = true;
                try{
                    let params = {
                        period: this.time_period,
                        between: this.between
                    }
                    let response = await this.getAmountInPipelineData(params)
                    this.amount_pipeline_list = response.response.pipeline_amount
                    const result = []
                    const map = new Map();
                    for (const item of this.amount_pipeline_list) {
                        if(!map.has(item.total)){
                            map.set(item.total, true);
                            result.push({
                                network: item.pipeline_name || '',
                                MAU:item.total
                            });
                        }
                    }
                    this.amount_pipeline_list = result
                    if(this.amount_pipeline_list ==''){
                        this.loadAmountInPipelineSection = false;
                        setTimeout(() => {
                            var style = document.createElement('style');
                            style.type = 'text/css';
                            style.innerHTML = '.salesCss {width: 60%!important;height: 60%!important;margin:auto!important;}';
                            document.getElementsByTagName('head')[0].appendChild(style);
                            document.getElementById('pipelineDiv').innerHTML = "<div class=text-center><img id= pipeline-img src=/static/images/customers.png class=mt-3><div class='mt-4 text-muted fw-500'>No amount in pipeline!</div></div>";
                            document.getElementById('pipeline-img').className = 'salesCss';
                        }, 1000);
                    } else {
                        this.loadAmountInPipelineSection = false;
                        this.loadAmountInPipelineData()
                    }
                    this.loadAmountInPipelineSection = false;
                }catch (reason){
                    this.loadAmountInPipelineSection = false;
                }
            },
            //Amchart code to show amount in pipeline chart
            async loadAmountInPipelineData() {
                setTimeout(() => {
                    let vueThis = this
                    var chart = am4core.create("pipelineDiv", am4charts.XYChart);
                    chart.padding(40, 40, 40, 40);

                    var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
                    categoryAxis.renderer.grid.template.location = 0;
                    categoryAxis.dataFields.category = "network";
                    categoryAxis.renderer.minGridDistance = 1;
                    categoryAxis.renderer.inversed = true;
                    categoryAxis.renderer.grid.template.disabled = true;
                    categoryAxis.title.text = "Revenue"
                    categoryAxis.title.fontWeight = 600;
                    categoryAxis.numberFormatter.numberFormat = "#a";

                    var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
                    valueAxis.min = 0;
                    valueAxis.title.text = "Amount in 1000(" +vueThis.currency+ ") ";
                    valueAxis.title.fontWeight = 600;

                    var series = chart.series.push(new am4charts.ColumnSeries());
                    series.dataFields.categoryY = "network";
                    series.dataFields.valueX = "MAU";
                    //series.tooltipText = "{[{valueX}: bold]{categoryY}[/]}"
                    series.columns.template.strokeOpacity = 0;
                    series.columns.template.column.cornerRadiusBottomRight = 5;
                    series.columns.template.column.cornerRadiusTopRight = 5;

                    var labelBullet = series.bullets.push(new am4charts.LabelBullet())
                    labelBullet.label.horizontalCenter = "left";
                    labelBullet.label.dx = 10;
                    labelBullet.label.text = "{values.valueX.workingValue.formatNumber('#.0as')}";
                    labelBullet.locationX = 1;

                    // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
                    series.columns.template.adapter.add("fill", function (fill, target) {
                        return chart.colors.getIndex(target.dataItem.index);
                    });

                    categoryAxis.sortBySeries = series;
                    chart.data = vueThis.amount_pipeline_list
                }, 1000);
            },
            //API call to load target achieved by team data and amchart method
            async loadTargetAchievedByTeamData() {
                this.loadTargetAchievedSection = true;
                let params = {
                    period: this.time_period,
                    between: this.between
                }
                let response = await this.getTargetAchievedByTeamData(params)
                this.target_achieved = response.response

                if(this.target_achieved.percentage_active == '' && this.target_achieved.percentage_lost == '' && this.target_achieved.percentage_won == ''){
                    this.loadTargetAchievedSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML = '.targetDataCss {width: 60%!important;height: 60%!important;margin:auto!important;margin-top:20px !important}';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('targetDiv').innerHTML = "<div class=text-center><img id= targetData-img src=/static/images/survey-type.png class=mt-3><div class='mt-5 text-muted fw-500'>No Targets yet!</div></div>";
                        document.getElementById('targetData-img').className = 'targetDataCss';
                    }, 1000);
                } else {
                    this.loadTargetAchievedSection = false;
                    setTimeout(() => {
                        // Create chart instance
                        var chart = am4core.create("targetDiv", am4charts.PieChart);

                        // Add data
                        chart.data = [{
                            "country": "Pipeline",
                            "litres": this.target_achieved.percentage_active
                            }, {
                            "country": "Won",
                            "litres": this.target_achieved.percentage_won
                            }, {
                            "country": "Lost",
                            "litres": this.target_achieved.percentage_lost
                        }];

                        // Add and configure Series
                        var pieSeries = chart.series.push(new am4charts.PieSeries());
                        pieSeries.dataFields.value = "litres";
                        pieSeries.dataFields.category = "country";

                        // Let's cut a hole in our Pie chart the size of 40% the radius
                        chart.innerRadius = am4core.percent(40);

                        // Disable ticks and labels
                        pieSeries.labels.template.disabled = false;
                        pieSeries.ticks.template.disabled = true;
                        pieSeries.alignLabels = false;
                        pieSeries.labels.template.bent = true;

                        // Disable tooltips
                        pieSeries.slices.template.tooltipText = "";

                        // Add a legend
                        chart.legend = new am4charts.Legend();
                    }, 1000);
                }
            },
            //API call to load revenue generated data
            async loadRevenueGenerstedAPI(){
                this.loadRevenueGeneratedSection = true;
                try {
                    let params ={
                        range: this.created_report_date
                    }
                    let response = await this.getSalesRevenueData(params)
                    this.revenue_generated_data = response.response.timing
                    const result = []
                    const map = new Map();
                    for (const item of this.revenue_generated_data) {
                        map.set(item.total, true);
                        result.push({
                            date: item.concat_time || '',
                            value:item.total
                        });
                    }
                    this.graph_scale = response.response.graph_scale
                    const scale = []
                    for (const scaledata of this.graph_scale) {
                        scale.push(scaledata)
                    }

                    this.graph_scale = scale
                    this.revenue_generated_data = result
                    this.loadRevenueGeneratedSection = false;

                } catch (reason) {
                    this.loadRevenueGeneratedSection = false;
                }
                if(this.graph_scale == ''){
                    this.loadRevenueGeneratedSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML = '.revDataCss {width: 60%!important;height: 60%!important;margin:auto!important;margin-top:20px !important}';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('revenueDiv').innerHTML = "<div class=text-center><img id= revData-img src=/static/images/forecast.png class=mt-3><div class='mt-4 text-muted fw-500'>No Revenue generated!</div></div>";
                        document.getElementById('revData-img').className = 'revDataCss';
                    }, 1000);
                } else {
                    this.loadRevenueGeneratedSection = false;
                    this.loadReveuneGeneratedData()
                }
            },
            //Amchart code to show revenue generated data in chart
            loadReveuneGeneratedData() {
                setTimeout(() => {
                    let vueThis = this
                    // Themes begin
                    am4core.useTheme(am4themes_animated);
                    // Themes end

                    var chart = am4core.create("revenueDiv", am4charts.XYChart);
                    chart.paddingRight = 40;

                    var data = [];
                    var value = 50;
                    for (let i = -3650; i < 0; i++) {
                    let date = new Date();
                    date.setHours(0, 0, 0, 0);
                    date.setDate(i);
                    value -= Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
                    if (value < 0) {
                        value = Math.round(Math.random() * 10);
                    }
                    data.push({ date: date, value: value });
                    }

                    chart.data = this.revenue_generated_data;

                    // Create axes
                    var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                    dateAxis.renderer.minGridDistance = 60;
                    dateAxis.groupData = true;
                    dateAxis.title.text = "Time"
                    dateAxis.title.fontWeight = 600;

                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                    valueAxis.title.text = "Revenue in 1000(" + vueThis.currency + ") ";
                    valueAxis.title.fontWeight = 600;
                    valueAxis.numberFormatter.numberFormat = "#a";
                    //create label
                    var ylabel = valueAxis.renderer.labels.template;
                    ylabel.truncate = true;
                    ylabel.maxWidth = 80;
                    ylabel.tooltipText = "{value}";

                    // Create series
                    var series = chart.series.push(new am4charts.ColumnSeries());
                    series.dataFields.valueY = "value";
                    series.dataFields.dateX = "date";
                    series.tooltipText = "{value}"

                    series.tooltip.pointerOrientation = "vertical";

                    chart.cursor = new am4charts.XYCursor();

                    chart.scrollbarX = new am4core.Scrollbar();
                }, 1000);
            },
            //API call to get sales generated data by sales person
            async loadSalesGeneratedPerPersonAPI(){
                this.loadSalesGeneratedSection = true;
                try{
                    let params = {
                        period: this.time_period,
                        between: this.between
                    }
                    let response = await this.getSalesGeneratedData(params)
                    this.sales_generated = response.response.sales_people
                    const result = []
                    const map = new Map();
                    for (const item of this.sales_generated) {
                        if(!map.has(item.achieved)){
                            map.set(item.achieved, true);
                            result.push({
                                country: item.full_name || '',
                                visits:item.achieved
                            });
                        }
                    }
                    this.sales_generated = result
                    this.loadSalesGeneratedSection = false;

                }catch (reason){
                    this.loadSalesGeneratedSection = false;
                }
                if(this.sales_generated == ''){
                    this.loadSalesGeneratedSection = false;
                    setTimeout(() => {
                        var style = document.createElement('style');
                        style.type = 'text/css';
                        style.innerHTML = '.salesGenCss {width: 50%!important;height: 50%!important;margin:auto!important;margin-top:20px !important}';
                        document.getElementsByTagName('head')[0].appendChild(style);
                        document.getElementById('salesDiv').innerHTML = "<div class=text-center><img id= sales-img src=/static/images/response.png class=mt-3><div class='mt-4 text-muted fw-500'>No History of Sales!</div></div>";
                        document.getElementById('sales-img').className = 'salesGenCss';
                    }, 1000);
                } else {
                    this.loadSalesGeneratedSection = false;
                    this.loadSalesGeneratedPerPersonData()
                }
            },
            //Amchar code to show sales generated data by sales person
            loadSalesGeneratedPerPersonData() {
                setTimeout(() => {
                    let vueThis = this
                    am4core.useTheme(am4themes_animated);
                    var chart = am4core.create("salesDiv", am4charts.XYChart);
                    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
                    chart.data = vueThis.sales_generated

                    var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                    categoryAxis.renderer.grid.template.location = 0;
                    categoryAxis.dataFields.category = "country";
                    categoryAxis.renderer.minGridDistance = 10;
                    categoryAxis.title.text = "Sale Persons";
                    categoryAxis.title.fontWeight = 600;

                    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                    valueAxis.min = 0;
                    valueAxis.renderer.grid.template.location = 0;
                    valueAxis.dataFields.category = "visits";
                    valueAxis.renderer.minGridDistance = 30;
                    valueAxis.title.text = "Revenue in 1000(" + vueThis.currency + ") ";
                    valueAxis.title.fontWeight = 600;
                    valueAxis.numberFormatter.numberFormat = "#a";

                    //create label
                    var label = categoryAxis.renderer.labels.template;
                    label.truncate = true;
                    label.maxWidth = 50;
                    label.tooltipText = "{country}";

                    var ylabel = valueAxis.renderer.labels.template;
                    ylabel.truncate = true;
                    ylabel.maxWidth = 80;
                    ylabel.tooltipText = "{visits}";

                    categoryAxis.events.on("sizechanged", function(ev) {
                    var axis = ev.target;
                    var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
                    if (cellWidth < axis.renderer.labels.template.maxWidth) {
                        axis.renderer.labels.template.rotation = -45;
                        axis.renderer.labels.template.horizontalCenter = "right";
                        axis.renderer.labels.template.verticalCenter = "middle";
                    }
                    else {
                        axis.renderer.labels.template.rotation = 0;
                        axis.renderer.labels.template.horizontalCenter = "middle";
                        axis.renderer.labels.template.verticalCenter = "top";
                    }
                    });

                    var series = chart.series.push(new am4charts.ColumnSeries());
                    series.dataFields.categoryX = "country";
                    series.dataFields.valueY = "visits";
                    series.columns.template.tooltipText = "{valueY.value}";
                    series.columns.template.tooltipY = 0;
                    series.columns.template.strokeOpacity = 0;

                    // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
                    series.columns.template.adapter.add("fill", (fill, target) => {
                    return chart.colors.getIndex(target.dataItem.index);
                    });
                }, 1000);
            }
        },
        watch: {
            selected_type() {
                if (this.selected_type == 'month') {
                    this.open = true
                } else {
                    this.open = false
                }
            }
        },
        computed: {
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
            userPermissions(){
                return this.$store.getters.userPermissions;
            }
        },
        async mounted() {
            this.pageDataLoading = true;
            this.dateSettings();
            this.currency = this.loggedInUser.currency.symbol;
            this.loadRevenueGenerstedAPI(),
            this.loadTargetAchievedByTeamData(),
            this.loadDealsInPipelineData(),
            this.loadAmountInPipelineDataAPI(),
            this.loadSalesGeneratedPerPersonAPI(),
            setTimeout(() => {    
                (function() {
                $(function() {
                    $('.period-dropdown > a').on('click', function(e) {
                    var submenu;
                    submenu = $(this);
                    $('.period-dropdown .period-dropdown-menu').removeClass('show');
                    submenu.next('.period-dropdown-menu').addClass('show');
                    e.stopPropagation();
                    });
                    return $('.perioddropdown').on('hidden.bs.dropdown', function() {
                    // hide any open menus when parent closes
                    $('.period-dropdown-menu.show').removeClass('show');
                    });
                });
                }).call(this);
                this.pageDataLoading = false
            }, 1000);
        }
    }
</script>
<style scoped>
    .hello {
        width: 100%;
        height: 500px;
    }
    .card-item {
        padding: 18px 18px 30px 18px;
        border-radius: 6px;
    }
    .deals-cards {
        padding: 18px !important
    }
    .team-listview-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 5px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-listview-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-listview-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .card-item-contact {
        padding: 18px;
        border-radius: 6px;
    }
    .ml-32px {
        margin-left: 32px;
    }
    #leadsDiv {
        width: 100%;
        height: 200px;
    }
    #dealsDiv {
        width: 100%;
        height: 200px;
    }
    #territoryDiv {
        width: 100%;
        height: 200px;
        background-image: linear-gradient(to bottom, #003e96, #001f4b);
    }
    #contractDiv {
        width: 100%;
        height: 340px;
    }
    #campaignDiv {
        width: 100%;
        height: 340px;
    }
    .targetDiv {
        width: 100%;
        height: 340px;
    }
    .targetDiv-expand {
        width: 100%;
        height: 650px;
    }
    .salesDiv {
        width: 100%;
        height: 400px;
    }
    .salesDiv-expand {
        width: 100%;
        height: 650px;
    }
    .logo-image {
        width: 40px;
        height: 55px;
    }
    .contracts-logo {
        position: relative;
        bottom: 20px;
    }
    .pb-10px {
        padding-bottom: 10px;
    }
    .ongoing-survey-logo-image {
        width: 40px;
        height: 55px;
    }
    .meetings {
        border: 1px solid #00448b;
        border-radius: 4px;
        padding-top: 8px;
    }
    #targetachievedDiv {
        width: 100%;
        height: 300px;
    }
    .pipelineDiv {
        width: 100%;
        height: 340px;
    }
    .pipelineDiv-expand{
        width: 100%;
        height: 650px;
    }
    .revenueDiv {
        width: 100%;
        height: 340px;
    }
    .revenueDiv-expand {
        width: 100%;
        height: 650px;
    }
    .salesValue {
        width: 100%;
        height: 340px;
        border: 1px solid #7faed6;
        border-radius: 5px;
        overflow:scroll !important;
    }
    .salesValue-expand{
        width: 100%;
        height: 820px;
        border-radius: 5px;
        overflow:scroll !important;
    }
    .text-rotate {
        transform: rotate(-90deg);
        position: relative;
        right: 316px;
        top: 150px;
    }
    .table-properties {
        border-collapse: collapse;
        max-height: 336px;
        width: 100%;
    }
    table thead th,
    table tbody td {
        padding: 10px;
    }
    #days {
        cursor: pointer;
    }
    .expand-img {
        width: 18px;
        margin-bottom: 2px;
    }
    .today-meetings {
        min-height: 377px;
        max-height: 377px;
        overflow: auto;
    }
    .icon-images {
        width: 24px;
        padding-right: 10px;
    }
    .copy-icon-images {
        width: 30px;
    }
    .mediaDiv {
        border: 1px solid #6491cb;
        border-radius: 2px;
        height: 200px
    }
    .icon_div {
        background-color: #ffe1dd;
        border: 1px solid #ccc;
        color: #ef1747;
    }
    .icon_div_green {
        background-color: #cce8e0;
        border: 1px solid #ccc;
        color: #008a63;
    }
    .contactMedia {
        width: 100%;
        height: 280px !important;
    }
    .box-radius{
        border-radius: 7px !important;
    }
    .sales-list{
        width: 35%!important;
		height: 35%!important;
		margin: auto!important;
    }
    .dropdown-button{
        background-color: #fff !important;
        height: 30px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        padding: 0 1.5rem;
    }
    .dropdown-button:focus{
        border: 1px solid #0F5DAF !important;
    }
    .downarrow-size::after {
        font-size: 20px;
    }
    .dropdown-button span{
        color: #000;
        font-weight: 400;
    }
    .dropdown-submenu {
        position: relative;
        padding: 0;
    }
    .dropdown-item-toggle {
        margin-right:5px;
    }
    .dropdown-item-toggle::after {
        position: absolute;
        right: 7px;
        content: '▸';
        color: #aaa;
        margin-left: 0.5rem;
    }
    .dropdown-menu {
        top: 4px !important;
        left: 10px !important;
        margin-top: -1px;
        border-radius: 8px;
    }
    .sub-dropdown{
        left: -80% !important;
        width: 78%;
        margin: 0px;
        padding: 0px;
    }
    .dropdown-label{
        font-size: 16px;
        font-weight: 400;
        margin-right: 8px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/DealsDashboard.vue